import { notifyError, notifySuccess } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";
import { singleAuctionDetails } from "./singleAuction";

export const startingPriceApproval = (auctionID, setIsAcceptModalOpen) => async (dispatch) => {
    dispatch({ type: "STARTING_PRICE_APPROVED_LOADING" });
    try {
        const { data } = await auction.put(
            `/auction/update/industry/starting-price-approval/${auctionID}`
        );
        setIsAcceptModalOpen(false);
        dispatch({ type: "STARTING_PRICE_APPROVED_SUCCESS", payload: data });
        notifySuccess("Starting price has been approved");
        dispatch(singleAuctionDetails(auctionID));
    } catch (error) {
        notifyError(
            error.response ? error.response?.data : error.message,
            error.response?.status
        );
        dispatch({ type: "STARTING_PRICE_APPROVED_FAILED" });
    }
};

export const startingPriceReject = (auctionID, setIsRejectModalOpen) => async (dispatch) => {
    dispatch({ type: "STARTING_PRICE_APPROVED_LOADING" });
    try {
        const { data } = await auction.put(
            `/auction/update/industry/starting-price-reject/${auctionID}`
        );
        setIsRejectModalOpen(false);
        dispatch({ type: "STARTING_PRICE_APPROVED_SUCCESS", payload: data });
        notifySuccess("Starting price has been rejected");
        dispatch(singleAuctionDetails(auctionID));
    } catch (error) {
        notifyError(
            error.response ? error.response?.data : error.message,
            error.response?.status
        );
        dispatch({ type: "STARTING_PRICE_APPROVED_FAILED" });
    }
};